import FooterStaticPages from "./FooterStaticPages";
export default FooterStaticPages;
